import { render, staticRenderFns } from "./CadastrarEditarMaterialDialog.vue?vue&type=template&id=6a8d25ed&scoped=true"
import script from "./CadastrarEditarMaterialDialog.vue?vue&type=script&lang=js"
export * from "./CadastrarEditarMaterialDialog.vue?vue&type=script&lang=js"
import style0 from "./CadastrarEditarMaterialDialog.vue?vue&type=style&index=0&id=6a8d25ed&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6a8d25ed",
  null
  
)

export default component.exports